import { memo, PropsWithChildren } from 'react';
import { Focusable } from 'react-aria-components';

import { Tooltip, TooltipTrigger } from '@/components/core';
import { HelpIcon } from '@/components/icons';

type BasicTooltipProps = {
  placement?: 'top' | 'bottom' | 'left' | 'right';
};

const IBasicTooltip = ({ placement, children }: PropsWithChildren<BasicTooltipProps>) => {
  return (
    <TooltipTrigger>
      <Tooltip variant="primary" placement={placement ?? 'right'} className="max-w-[16rem]">
        {children}
      </Tooltip>
      <Focusable excludeFromTabOrder>
        <HelpIcon role="button" tabIndex={-1} className="text-gray-400" />
      </Focusable>
    </TooltipTrigger>
  );
};

export const BasicTooltip = memo(IBasicTooltip);
